export default __webpack_public_path__ + "static/media/icn-settings.a763c249.svg";